var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-storage"},_vm._l((_vm.images),function(image,i){return _c('img',{key:i,style:(i == _vm.activeIndex ? 'z-index: 99' : ''),attrs:{"src":image,"alt":""},on:{"click":_vm.onClick}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }